<template>
   <div>
      <div class="spinner-container" v-if="loadingPage">
         <BeatLoader color="#1389EF" />
      </div>
      <div v-else>
         <form @submit.prevent="valider">
            <div class="columns">
               <div class="column is-half">
                  <b-field label="Nom" :type="form.errors.has('nom') ? 'is-danger' : ''" :message="form.errors.get('nom')">
                     <b-input v-model="form.nom"></b-input>
                  </b-field>
               </div>
               <div class="column is-half">
                  <b-field label="Type de ruche" :type="form.errors.has('type') ? 'is-danger' : ''" :message="form.errors.get('type')">
                     <b-select placeholder="Choisir ..." v-model="form.type" expanded>
                        <option v-for="type in types" :value="type" :key="type">{{ type }}</option>
                     </b-select>
                  </b-field>
               </div>
            </div>
            <div class="columns">
               <div class="column is-half">
                  <b-field label="Lignée" :type="form.errors.has('lignee') ? 'is-danger' : ''" :message="form.errors.get('lignee')">
                     <b-input v-model="form.lignee"></b-input>
                  </b-field>
               </div>
               <div class="column is-half">
                  <b-field label="Année de naissance de la reine" :type="form.errors.has('annee_naissance_reine') ? 'is-danger' : ''" :message="form.errors.get('annee_naissance_reine')">
                     <b-input v-model="form.annee_naissance_reine"></b-input>
                  </b-field>
               </div>
            </div>
            <div class="flex" style="justify-content:space-between">
               <b-button style="margin-top:25px" icon-left="check" size="is-medium" native-type="submit" type="is-primary">Valider</b-button>
               <b-button style="margin-top:25px" icon-left="arrow-left" size="is-medium" type="is-light" @click="back">Retour</b-button>
            </div>
         </form>
      </div>
   </div>
</template>

<script>
import { BeatLoader } from '@saeris/vue-spinners';
import { Form } from 'vform';
import axios from 'axios';

export default {
   props: {
      mode: String
   },
   components: { BeatLoader },
   data() {
      return {
         loading: false,
         loadingPage: false,
         form: new Form({
            nom: '',
            lignee: '',
            details_lignee: '',
            annee_naissance_reine: '',
            type: 'Dadant'
         })
      };
   },
   computed: {
      types() {
         return this.$store.state.types_ruches;
      }
   },
   mounted() {
      if (this.mode === 'edit') {
         this.getRuche();
      }
   },
   methods: {
      back() {
         window.history.back();
      },
      getRuche() {
         this.loadingPage = true;
         let id = this.$route.params.id;
         axios.get('/ruches/' + id).then(res => {
            if (res.data.erreur) {
               this.$buefy.toast.open({
                  message: res.data.erreur,
                  type: 'is-danger'
               });
               this.$router.push({ name: 'ruches' });
            }
            this.form.fill(res.data);
            this.loadingPage = false;
         });
      },
      valider() {
         this.loading = true;

         // si c'est une création
         if (this.mode === 'create') {
            this.form
               .post('/ruches')
               .then(res => {
                  this.loading = false;
                  if (res.data.erreur) {
                     this.$buefy.toast.open({
                        message: res.data.erreur,
                        type: 'is-danger'
                     });
                  } else {
                     this.$buefy.toast.open({
                        message: `Ruche créée avec succès.`,
                        type: 'is-success'
                     });
                     this.$router.push({ name: 'ruches' });
                  }
               })
               .catch(() => {
                  this.$buefy.toast.open({
                     message: `Des erreurs ont été trouvées.`,
                     type: 'is-danger'
                  });
                  this.loading = false;
               });
         }
         // fin creation

         // si c'est une modification
         if (this.mode === 'edit') {
            this.form
               .put('/ruches/' + this.$route.params.id)
               .then(res => {
                  this.loading = false;
                  if (res.data.erreur) {
                     this.$buefy.toast.open({
                        message: res.data.erreur,
                        type: 'is-danger'
                     });
                  } else {
                     this.$buefy.toast.open({
                        message: `Ruche modifiée avec succès.`,
                        type: 'is-success'
                     });
                     this.$router.push({ name: 'ruches' });
                  }
               })
               .catch(() => {
                  this.$buefy.toast.open({
                     message: `Des erreurs ont été trouvées.`,
                     type: 'is-danger'
                  });
                  this.loading = false;
               });
         }
      }
   }
};
</script>
